import { hash } from '../utils/functions.js'
import service from 'auth/FetchInterceptor.js'

const AuthService = {}

AuthService.login = async function (data) {
  const raw_password = data.password
  data.password = hash(raw_password)
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v2/authentication/login/?lang=en`
      : '/portal-backend/v2/authentication/login/?lang=en',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  }

  return await service(config).catch((error) =>{ 
  if(error.response){
    if(error.response.data["code"] !== undefined){
      if(error.response.data["code"] === 7001){
        config.data.password = raw_password
        config.data.is_hashed = 0
        return service(config)
      }
    }
   }
   throw error
})
}

AuthService.loginAdmin = async function (data) {
  const raw_password = data.password
  data.password = hash(raw_password)
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1.1/authentication/login/`
      : '/admin-portal-backend/v1.1/authentication/login/ ',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  }

  return await service(config).catch((error) =>{ 
    if(error.response){
      if(error.response.data["code"] !== undefined){
        if(error.response.data["code"] === 7001){
          config.data.password = raw_password
          config.data.is_hashed = 0
          return service(config)
        }
      }
     }
     throw error
  })
}

AuthService.adminRefreshToken = async function () {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/authentication/refresh/`
      : '/admin-portal-backend/v1/authentication/refresh/ ',
    headers: {
      'Content-Type': 'application/json',
    },
  }

  return await service(config)
}

AuthService.sspRefreshToken = async function () {
  const config = {
    method: 'post',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/authentication/refresh/?lang=en`
      : '/portal-backend/v1/authentication/refresh/?lang=en',
    headers: {
      'Content-Type': 'application/json',
    },
  }

  return await service(config)
}

AuthService.logout = async function () {
  const config = {
    method: 'get',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/portal-backend/v1/authentication/logout/`
      : '/portal-backend/v1/authentication/logout/',
  }

  return await service(config)
}

AuthService.logoutAdmin = async function () {
  const config = {
    method: 'get',
    url: process.env.REACT_APP_DOMAIN_NAME
      ? `${process.env.REACT_APP_DOMAIN_NAME}/admin-portal-backend/v1/authentication/logout/`
      : '/admin-portal-backend/v1/authentication/logout/',
  }

  return await service(config)
}

export default AuthService
